import React from 'react';
import { motion } from 'framer-motion';
import { Product } from '../../types/Product';
import { ProductCard } from './ProductCard';

interface ProductListProps {
  products: Product[];
  onRemoveProduct: (id: string) => void;
  onUpdateQuantity: (id: string, quantity: number) => void;
  quantities: Record<string, number>;
}

export const ProductList: React.FC<ProductListProps> = ({
  products,
  onRemoveProduct,
  onUpdateQuantity,
  quantities
}) => {
  const totalPrice = products.reduce((sum, product) => 
    sum + product.current_price * (quantities[product.id] || 1), 0
  );

  return (
    <div className="space-y-4">
      {products.map(product => (
        <ProductCard
          key={product.id}
          product={product}
          quantity={quantities[product.id] || 1}
          onRemove={() => onRemoveProduct(product.id)}
          onUpdateQuantity={(quantity) => onUpdateQuantity(product.id, quantity)}
        />
      ))}
      
      {products.length > 0 && (
        <div className="flex justify-between items-center p-4 bg-orange-50 rounded-lg">
          <span className="font-medium">Total:</span>
          <span className="text-xl font-bold text-orange-600">
            {totalPrice.toFixed(2)}€
          </span>
        </div>
      )}
    </div>
  );
};